export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 80
// module chunks = 0